'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import PropTypes from 'prop-types';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { jsx as _jsx } from "react/jsx-runtime";
const NoAccessError = ({
  use
}) => {
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    illustration: "keys",
    title: use === 'preview' ? unescapedText('appMarketplace.error.noPreviewAccess.title') : unescapedText('appMarketplace.error.noAccess.title'),
    children: /*#__PURE__*/_jsx(UIRouterButton, {
      use: "tertiary",
      className: "m-top-4",
      to: "/",
      onClick: event => {
        if (use === 'preview') {
          event.preventDefault();
        }
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.error.notFound.button"
      })
    })
  });
};
NoAccessError.propTypes = {
  use: PropTypes.oneOf(['default', 'preview'])
};
NoAccessError.defaultProps = {
  use: 'default'
};
export default NoAccessError;